import styled from "styled-components";

export const CenterWrapper = styled.div`
    display: flex;
    justify-content: center;
`;